module.exports = __webpack_public_path__ + "static/assets/popust25.11533245.jpg";